module.exports = __WEBPACK_EXTERNAL_MODULE_20__;


//////////////////
// WEBPACK FOOTER
// external {"root":"ReactDOM","commonjs2":"react-dom","commonjs":"react-dom","amd":"react-dom"}
// module id = 20
// module chunks = 0 1